import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import InvoicingGroupEditor from "../../editors/catalogue/invoicingGroup";

const InvoicingGroups: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.InvoicingGroupsList}
			endpoint={Endpoint.InvoicingGroups}
			addScreen={{ screen: InvoicingGroupEditor, isAllowed: hasPermission(Permission.InvoicingGroupsAdd) }}
			editScreen={{ screen: InvoicingGroupEditor, isAllowed: hasPermission(Permission.InvoicingGroupsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.InvoicingGroupsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default InvoicingGroups;
